module.exports = __webpack_public_path__ + "static/media/burger_family_deals-mb-fr.253c1cec.jpg";